import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IProjectFollowUpTask } from "../../utils/types/models";

export default createEntityReducer<IProjectFollowUpTask>(Endpoint.ProjectFollowUpTasks, Endpoint.ProjectFollowUpTasksList);
